<template>
  <div class="page page-bg">
    <div class="weui-msg">
      <div class="weui-msg__icon-area">
        <img src="../../assets/images/logo-white.png" class="app-logo" />
      </div>
      <div class="weui-msg__text-area">
        <h2 class="weui-msg__title">登录华商云服网页版</h2>
        <p class="weui-msg__desc text-error" v-if="!isValidClient">请使用华商云服APP扫描</p>
        <p class="weui-msg__desc" v-if="clientInfo">IP：{{clientInfo.ip}}</p>
        <p class="weui-msg__desc text-success" v-if="success">登录成功</p>
      </div>
      <div class="weui-msg__opr-area">
        <p v-if="clientInfo && !success" class="weui-btn-area">
          <a @click="login" class="weui-btn weui-btn_default">登录</a>
        </p>
      </div>
    </div>
  </div>
</template>
  
<script>
import Session from "@/util/session";
// socket统一走saas-api，不走saas-pre-api
const baseURL = process.env.VUE_APP_API_URL || process.env.BASE_URL || "";

export default {
  data() {
    return {
      isValidClient: false,
      clientInfo: null,
      success: false,
    };
  },
  mounted() {
    this.isValidClient = Session.valid();
    if (this.isValidClient) {
      this.getClientInfo();
    }
  },
  methods: {
    getClientInfo() {
      const me = this;
      let code = me.$route.query.code;
      if (!code) {
        me.$weui.topTips("参数错误，请重新扫描", 3000);
        return;
      }
      me.$ajax({
        url: baseURL + "/api/auth/qrcode/read",
        params: {
          code,
        },
      }).then(function (res) {
        if (res.success) {
          me.clientInfo = res.data;
        } else {
          me.$weui.topTips(res.message, 3000);
        }
      });
    },
    login() {
      const me = this;
      let code = me.$route.query.code;
      if (!code) {
        me.$weui.topTips("参数错误，请重新扫描", 3000);
        return;
      }
      me.$loading({
        url: baseURL + "/api/auth/qrcode/confirm",
        method: "POST",
        params: {
          code,
        },
      }).then(function (res) {
        if (res.success) {
          me.success = true;
          me.$weui.toast("登录成功", {
            duration: 500,
            callback: function () {
              me.$router.back();
            },
          });
        } else {
          me.$weui.topTips("登录失败：" + res.message, 3000);
        }
      });
    },
  },
};
</script>

<style scoped>
.app-logo {
  width: 180px;
}
</style>